/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react'
import { Field } from 'formik'
import {
  Container,
  OptionsContainer,
  OptionWrapper,
  CheckboxInput,
  OptionText,
  OptionText2,
  DivOptions,
  OptionText3,
} from './styles'
import TplGroup from '../tpl-group'
import IField from '../../../../interfaces/field'

type IProps = any & IField

const InputCheck = ({
  required = false,
  name,
  prefixName = '',
  title,
  options,
  onChange,
  ...el
}: IProps) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(null)

  const handleOptionClick = (value: string) => {
    setSelectedOption((prevSelectedOption) => (prevSelectedOption === value ? null : value))
    if (onChange) {
      onChange(value)
    }
  }

  return (
    <TplGroup
      name={`${prefixName}${name}`}
      prefixName={prefixName}
      title={title}
      required={required}
      onChange={onChange}
      {...el}
    >
      <Container>
        <OptionsContainer>
          {options.map((option: any) => (
            <OptionWrapper
              key={JSON.stringify(option)}
              onClick={() => handleOptionClick(option.value)}
              selected={option.value === selectedOption}
            >
              <label>
                <Field
                  type="checkbox"
                  name={`${prefixName}${name}`}
                  value={String(option.value)}
                  as={CheckboxInput}
                  checked={option.value === selectedOption}
                  disabled={el?.disabled === true}
                />
                <div>{option?.name || option}</div>
              </label>
              <DivOptions>
                <OptionText selected={option.value === selectedOption}>
                  {option?.label || option}
                </OptionText>
                {option.label2 && (
                  <OptionText2 selected={option.value === selectedOption}>
                    {option?.label2 || option}
                  </OptionText2>
                )}
                <OptionText3>{option?.label3 || option}</OptionText3>
              </DivOptions>
            </OptionWrapper>
          ))}
        </OptionsContainer>
      </Container>
    </TplGroup>
  )
}

export default InputCheck
